import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import { SNACKBAR_VARIANTS } from '../../../utils/constants';

const SnakcBarHandler = props => {
  const { errorObj } = props;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => {
    const handleSnackbarDismiss = () => {
      closeSnackbar(key);
    };

    return <Button onClick={handleSnackbarDismiss}>Dismiss</Button>;
  };
  useEffect(() => {
    const variant = errorObj.variant ? errorObj.variant : SNACKBAR_VARIANTS.ERROR;
    enqueueSnackbar(errorObj.getMessage(), { action, variant, autoHideDuration: 5000 });
  }, [errorObj.key]);

  return null;
};

SnakcBarHandler.propTypes = {
  errorObj: PropTypes.object,
};

SnakcBarHandler.defaultProps = {
  errorObj: {},
};

export default SnakcBarHandler;
